import React, { useState, useEffect } from "react";
// material-ui
import { useTheme } from "@mui/material/styles";
import { Divider, Grid, Stack, Typography, useMediaQuery } from "@mui/material";

// project imports
import AuthWrapper1 from "../AuthWrapper1";
import AuthCardWrapper from "../AuthCardWrapper";
import FormField from "../FormFields";
import { AadharData } from "../../Axios/ServiceApi";

const Index = (props) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const [Pincode, setPincode] = useState("");
  const [State, setState] = useState("");
  const [City, setCity] = useState("");
  const [AadhaarFetchedName, setAadhaarFetchedName] = useState("");

  const DisableAadhaarButton = sessionStorage.getItem("Aadharfield");
  const reference_id = sessionStorage.getItem("reference_id");

  //     // aadhar data
  useEffect(() => {
    if (reference_id) {
      AadharData(setState, setPincode, setCity, setAadhaarFetchedName);
    }
  }, [reference_id]);
  // console.log("State", State, Pincode, City);

  return (
    <AuthWrapper1>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{ minHeight: "85vh" }}
      >
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "calc(85vh - 68px)" }}
          >
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <AuthCardWrapper>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  {/* <Grid item sx={{}}>
                    <Link to="#" underline="none">
                      <Logo />
                      <Typography sx={{color:"#A556B2"}} gutterBottom variant= 'h5'>
                        FI Lending
                      </Typography>
                    </Link>
                  </Grid> */}
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction={matchDownSM ? "column-reverse" : "row"}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid item>
                        <Stack
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <Typography
                            sx={{ color: "#121926" }}
                            gutterBottom
                            variant="h6"
                          >
                            Enter your CSP Details
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <FormField
                      city={City}
                      state={State}
                      pincode={Pincode}
                      aadharFetchedName={AadhaarFetchedName}
                      DisableAadhaarButton={DisableAadhaarButton}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={8}></Grid>
                </Grid>
              </AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          {/* <AuthFooter /> */}
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default Index;
